import { GoogleGenAI } from "@google/genai";

// Initialize securely - in a real app, this might be proxied or require specific setup
// However, the prompt instructions say to use process.env.API_KEY directly.
const ai = new GoogleGenAI({ apiKey: process.env.API_KEY });

/**
 * Generates a background image or mockup context using the Nano Banana model.
 * The prompt asks to use "Nano Banana" which maps to 'gemini-2.5-flash-image'.
 */
export const generateBrandBackground = async (
  prompt: string,
  brandColors: string[],
  aspectRatio: "1:1" | "3:4" | "4:3" | "9:16" | "16:9" = "16:9"
): Promise<string | null> => {
  try {
    const enhancedPrompt = `
      Create a high-quality, professional abstract background or product mockup scene.
      Style: Minimalist, modern, soft lighting.
      Colors to incorporate: ${brandColors.join(', ')}.
      Subject: ${prompt}.
      The image should be suitable for overlaying a logo on top.
      Do not include text.
    `;

    const response = await ai.models.generateContent({
      model: 'gemini-2.5-flash-image',
      contents: {
        parts: [{ text: enhancedPrompt }]
      },
      config: {
        imageConfig: {
          aspectRatio: aspectRatio
        }
      }
    });

    // Check for inline data (the image)
    for (const part of response.candidates?.[0]?.content?.parts || []) {
      if (part.inlineData) {
        return `data:${part.inlineData.mimeType};base64,${part.inlineData.data}`;
      }
    }

    return null;
  } catch (error) {
    console.error("Gemini Generation Error:", error);
    throw error;
  }
};
